import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

export function WarningRates(): ReactElement {
  return (
    <div
      className="d-flex align-items-center bg-warning bg-opacity-10 fw-medium text-center text-warning px-8px"
      style={{ height: 100 }}
    >
      <FormattedMessage id="error.MP_BRIDGE_INVALID_PRICE" />
    </div>
  );
}
